export const logoutFunction = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/';
};

export default logoutFunction;
